<template>
  <div role="progressbar" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="indeterminate ? undefined : normalizedValue" class="d-progress-bar" :style="{height: normalizedHeight}">
    <div class="background" :class="[colorClasses]" :style="[styles]" />
    <div class="bar">
      <template v-if="indeterminate">
        <div class="indeterminate long" :class="[colorClasses]" />
        <div class="indeterminate short" :class="[colorClasses]" />
      </template>
      <template v-else>
        <div class="determinate" :class="[colorClasses]" :style="{width: `${effectiveWidth}%`}" />
      </template>
    </div>
  </div>
</template>
<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    props: {
      active: {
        type: Boolean,
        default: true,
      },

      color: {
        type: String,
        default: 'primary-500',
      },

      height: {
        type: [Number, String],
        default: 7,
      },

      indeterminate: Boolean,

      /**
       * The percentage value for current progress
       */
      value: {
        type: [String, Number],
        default: 0,
      },
    },

    computed: {
      normalizedValue() {
        if (this.value < 0) {
          return 0;
        }

        if (this.value > 100) {
          return 100;
        }

        return parseFloat(this.value);
      },

      colorClasses() {
        return {
          [`bg-${this.color} border-${this.color}`]: true,
        };
      },

      styles() {
        const styles = {};
        styles.opacity = 0.3;
        styles.width = '100%';
        styles.height = this.normalizedHeight;

        return styles;
      },

      effectiveWidth() {
        return +this.normalizedValue * 100 / +100;
      },

      normalizedHeight() {
        let newHeight = this.height;
        if (!this.active) {
          newHeight = 0;
        }

        return `${parseFloat(newHeight)}px`;
      },
    },
  });
</script>